import { changeMapRef } from '@cobliteam/store';
import type React from 'react';
import { useEffect } from 'react';
import { useMap as useMapLeaflet } from 'react-leaflet';
import { useDispatch } from 'react-redux';

const UseMapProvider = ({ children }: { children: React.ReactNode }) => {
  const map = useMapLeaflet();
  const dispatch = useDispatch();

  useEffect(() => {
    if (map) dispatch(changeMapRef(map));

    return () => {
      dispatch(changeMapRef(undefined));
    };
  }, [dispatch, map]);

  return children;
};

export default UseMapProvider;
